import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { SITE } from "@/lib/site";
import { SERVICES } from "@/data/services";
import { AREAS } from "@/data/areas";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ink text-white pt-20 pb-28 md:pb-12 overflow-hidden">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-3 space-y-6">
        <Logo light />
        <p className="text-slate-300 max-w-sm leading-relaxed">
          {SITE.years} years of domestic, commercial and industrial plumbing across Sydney.
        </p>
        <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 text-sm text-slate-200 hover:text-brass transition-colors">
          <Instagram className="h-4 w-4" /> @austyleplumbing
        </a>
      </div>
      <div className="lg:col-span-5 grid grid-cols-2 sm:grid-cols-3 gap-6">
        <div>
          <p className="eyebrow text-brass mb-4">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-slate-300 hover:text-white text-sm">{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow text-brass mb-4">Company</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="text-slate-300 hover:text-white">About us</Link></li>
            <li><Link to="/services" data-testid="footer-services" className="text-slate-300 hover:text-white">All services</Link></li>
            <li><Link to="/24-hour-service" data-testid="footer-247" className="text-slate-300 hover:text-white">24/7 Service</Link></li>
            <li><Link to="/book" data-testid="footer-book" className="text-slate-300 hover:text-white">Book online</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-slate-300 hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow text-brass mb-4">Areas</p>
          <ul className="space-y-2.5 text-sm">
            {AREAS.filter((a) => a.feature).slice(0, 7).map((a) => (
              <li key={a.slug}><Link to={`/areas/${a.slug}`} data-testid={`footer-area-${a.slug}`} className="text-slate-300 hover:text-white">{a.name}</Link></li>
            ))}
            <li><Link to="/areas" data-testid="footer-areas" className="text-brass hover:text-white">All areas</Link></li>
          </ul>
        </div>
      </div>
      <div className="lg:col-span-4 space-y-4">
        <p className="eyebrow text-brass">Get in touch</p>
        <a href={SITE.tel} data-testid="footer-phone" className="flex items-center gap-3 font-wide font-extrabold text-2xl sm:text-3xl hover:text-brass transition-colors"><Phone className="h-6 w-6 text-brass" />{SITE.phone}</a>
        <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 text-slate-200 hover:text-white break-all"><Mail className="h-4 w-4 text-brass shrink-0" />{SITE.email}</a>
        <p className="flex items-center gap-3 text-slate-300"><MapPin className="h-4 w-4 text-brass shrink-0" />{SITE.area}</p>
        <p data-testid="footer-hours" className="flex items-start gap-3 text-slate-300"><Clock className="h-4 w-4 text-brass shrink-0 mt-1" /><span>On-site: {SITE.hoursSite}, {SITE.hoursSiteTime}<br /><Link to="/24-hour-service" className="text-white hover:text-brass">24/7 for blocked drains & emergencies</Link></span></p>
      </div>
    </div>
    <div className="container-x mt-16">
      <p className="font-wide font-black text-[18vw] lg:text-[13rem] leading-[0.8] tracking-tighter text-white/[0.06] select-none" aria-hidden="true">AUSTYLE</p>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-400 font-mono">
        <span>© {new Date().getFullYear()} Austyle Plumbing Pty Ltd · Licence {SITE.licence}</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Staff login</Link>
      </div>
    </div>
  </footer>
);
